import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import EmojiEmotionsRoundedIcon from '@mui/icons-material/EmojiEmotionsRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import { useCallback } from 'react';
import { createGetAccountInfoOutbound } from '../api/outbound/commonOutbounds';
import { ExpandableSection } from '../components/expandableSection';
import { MyCurrencyPanelItem } from '../components/myCurrencyPanelItem';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { PowerPlayerPanelItem } from '../panels/powerPlayerPanelItem';
import { showSettingsMessageBox } from '../redux/actions/messageBoxesActions';
import { thunkSetActivePanel } from '../redux/actions/panelsActions';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { DrawerButton } from './drawerButton';
import { ExpandableSectionPaddedDrawerContainer } from './drawerControl';
export const AccountExpandableDrawerSection = ({ closeDrawer }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const username = useAppSelector((state) => state.selfData.username);
    const isPowerPlayer = useAppSelector((state) => state.selfData.isPowerPlayer);
    const onClickViewSelf = useCallback(() => {
        dispatch(thunkSetActivePanel('self', socketSend));
        closeDrawer();
    }, [closeDrawer, dispatch, socketSend]);
    const onClickAccount = useCallback(() => {
        socketSend(createGetAccountInfoOutbound());
        closeDrawer();
    }, [closeDrawer, socketSend]);
    const onClickSettings = useCallback(() => {
        dispatch(showSettingsMessageBox());
        closeDrawer();
    }, [closeDrawer, dispatch]);
    if (!username) {
        return null;
    }
    return (_jsxs(ExpandableSection, { expandableSectionType: 'drawer-account', overrideExpandableSectionTypeTitle: username, colorType: 'drawer', children: [isPowerPlayer === true && (_jsx(PowerPlayerPanelItem, { isSelfPanel: false, isPowerPlayer: true, powerPlayerBoltColor: 'yellow' })), _jsx(MyCurrencyPanelItem, { renderSeparatePanelItems: false, showFreeDailyBonusButton: true }), _jsxs(ExpandableSectionPaddedDrawerContainer, { children: [_jsx(DrawerButton, { label: 'View Self', onClick: onClickViewSelf, startIcon: _jsx(EmojiEmotionsRoundedIcon, {}) }), _jsx(DrawerButton, { label: 'Account', onClick: onClickAccount, startIcon: _jsx(ManageAccountsRoundedIcon, {}) }), _jsx(DrawerButton, { label: 'Settings', onClick: onClickSettings, startIcon: _jsx(SettingsRoundedIcon, {}) })] })] }));
};
